// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1JomC","header":"ReportDetails_header__ncKQC","title":"ReportDetails_title__1QJpF","left":"ReportDetails_left__Y1Xeh"};